import { brandLoaderSrc } from "@humansignal/core";
import { cn } from "../../utils/bem";
import "./Loading.prefix.css";

const block = cn("loading-center");

/**
 * Shared page/section loading state. Centers the AfriAnnotate mark
 * (+ optional label) in the exact middle of whatever container it fills,
 * instead of the bare top-left "Loading…" text each page used to render.
 *
 * Props:
 *   text     — label under the mark (default "Loading…"); pass null to hide
 *   size     — mark size in px (default 44)
 *   fill     — span (most of) the viewport height so the mark sits at the
 *              true vertical center of the page; use for full-page / list
 *              loaders. Leave off for compact in-card loaders.
 *   minHeight — explicit min height of the centering box; overrides `fill`.
 *   className — extra class on the wrapper
 */
export const Loading = ({ text = "Loading…", size = 72, fill = false, minHeight, className }) => {
  const resolvedMinHeight =
    minHeight != null
      ? typeof minHeight === "number"
        ? `${minHeight}px`
        : minHeight
      : fill
        ? "calc(100dvh - var(--header-height, 48px) - 140px)"
        : "240px";

  return (
    <div
      className={block.mix(className).toClassName()}
      style={{ minHeight: resolvedMinHeight }}
      role="status"
      aria-live="polite"
    >
      <img
        className={block.elem("mark").toClassName()}
        src={brandLoaderSrc()}
        style={{
          width: typeof size === "number" ? `${size}px` : size,
          height: typeof size === "number" ? `${size}px` : size,
        }}
        alt=""
        aria-hidden="true"
      />
      {text ? <span className={block.elem("text").toClassName()}>{text}</span> : null}
    </div>
  );
};

export default Loading;
